import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import subDays from "date-fns/subDays";
import endOfDay from "date-fns/endOfDay";

@Module({
  namespaced: true,
  name: "TOUTransactionHistory"
})
export default class TOUTransactionHistory extends VuexModule {
  touTransactionHistoryStart = subDays(new Date(), 1);
  touTransactionHistoryEnd = endOfDay(new Date());

  @Mutation
  setouTransactionHistoryStart(date: Date) {
    this.touTransactionHistoryStart = date;
  }

  @Mutation
  setouTransactionHistoryEnd(date: Date) {
    this.touTransactionHistoryEnd = date;
  }
}
